import { type Question } from '@/types'

export const getQuestionByFormIndex = (
  questions: Question[],
  formIndex: string
) => {
  return questions?.find(
    (question) => question.form_index.toString() === formIndex
  )
}
